import React from 'react';
import { Headers, Items, ShippingAddress } from '../CommonRevolveOrderInfoWidget/CommonRevolveOrderInfoWidget';
import isEmpty from 'lodash/isEmpty';
import * as toolSelectors from '../../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { Spreadsheet, SubTitleText } from '../../DTInfoWidget.styles';

const DTRevolveOrderInfoWidget = () => {
  const revolveOrderInfoWidgetData = useSelector(toolSelectors.getSelectedLineItems) || [];
  const selectedOrder = useSelector(toolSelectors.getSelectedOrder);
  const shippingAddress = selectedOrder.shippingAddress || {};
  const orderNumber = selectedOrder.id; // TODO check if its valid, looks like we should rather get mapped value

  if (isEmpty(revolveOrderInfoWidgetData)) {
    return null;
  }

  return (
    <Spreadsheet className="fs-block">
      <SubTitleText>Order Number - {orderNumber}</SubTitleText>
      {!isEmpty(shippingAddress) && <ShippingAddress shippingAddress={shippingAddress} />}
      <Headers />
      <Items revolveOrderInfoWidgetData={revolveOrderInfoWidgetData} />
    </Spreadsheet>
  );
};

export default DTRevolveOrderInfoWidget;
